import React, { ReactNode, ReactElement } from 'react';
import classNames from 'classnames';
import { Button } from '@fiverr-private/button';
import { theme } from '@fiverr-private/theme';
import { Text } from '@fiverr-private/typography';
import { SystemIconType, SystemDetailedIconType } from '@fiverr-private/icons';
import { Center } from '@fiverr-private/layout_components';
import { useSocialButtonClickHandler } from '../../hooks/useSocialButtonClickHandler';
import { AuthenticationResponse } from '../../shared/constants/authenticationFlow';
import { SOCIAL_BUTTON_ICON_SIZE, SocialProvider } from './constants';
import { socialButtonClass } from './SocialButton.styles.ve.css';

interface SocialButtonProps {
    children: ReactNode;
    SocialIcon: (props: SystemIconType | SystemDetailedIconType) => ReactElement;
    provider: SocialProvider;
    className?: string;
    disabled?: boolean;
    onClick?: () => void;
    onSuccess?: (provider: SocialProvider, authenticationResponse: AuthenticationResponse) => void;
    onError?: (provider: SocialProvider, authenticationResponse: AuthenticationResponse) => void;
}

export const SocialButton = ({
    children,
    SocialIcon,
    provider,
    className,
    disabled,
    onClick,
    onSuccess,
    onError,
}: SocialButtonProps) => {
    const { onSocialButtonClick } = useSocialButtonClickHandler({ onClick, onSuccess, onError, provider });

    return (
        <Button
            variant="outline"
            intent="primary"
            className={classNames(socialButtonClass, className)}
            onClick={onSocialButtonClick}
            disabled={disabled}
        >
            {SocialIcon && (
                <Center minWidth={20}>
                    <SocialIcon size={SOCIAL_BUTTON_ICON_SIZE} color={theme.colors.grey_1200} />
                </Center>
            )}
            <Text size="b_md" fontWeight="semibold" color="bodyPrimary" width="100%">
                {children}
            </Text>
        </Button>
    );
};
